export default __webpack_public_path__ + "static/media/loai-1920.cb528969.webp";